<template>
  <div id="contenedor-editar-reporte-avance-fisico">
    <v-form
      v-model="formularioValido"
      ref="editarReporteAvanceFisico">
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-row>
            <custom-date-picker
              cols="12"
              md="3"
              v-model="reporteFisico.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
            <custom-select
              cols="12"
              md="9"
              v-model="reporteFisico.calidad"
              label="Calidad de los trabajos"
              :items="calidadTrabajos"
              itemText="text"
              itemValue="id"
              :rules="[mixReglas.requerido]">
            </custom-select>
            <custom-text-area
              cols="12"
              md="12"
              v-model="reporteFisico.comentarios"
              label="Comentario"
              rows="4"
              autoGrow
              :rules="[mixReglas.requerido]">
            </custom-text-area>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="6">
          <v-col
            cols="12"
            md="12">
            <v-switch
              v-model="reporteFisico.existeProblema"
              color="red darken-3"
              label="¿Existe algún problema?"
              inset
              @change="limparDescripcionProblema">
            </v-switch>
          </v-col>
          <custom-text-area
            cols="12"
            md="12"
            v-model="reporteFisico.descripcionProblema"
            label="Descripcion del problema"
            :disabled="!reporteFisico.existeProblema"
            rows="4"
            autoGrow>
          </custom-text-area>
        </v-col>
        <custom-text-field-orange
          :value="reporteFisico.avanceProgramado"
          label="Programado"
          md="4"
          readonly
          prefix="%">
        </custom-text-field-orange>
        <custom-text-field-blue
          :value="getSumarAvancePoderado"
          label="Físico"
          md="4"
          readonly
          prefix="%">
        </custom-text-field-blue>
        <custom-text-field
          :value="porcentajeAtraso"
          :label="tituloPorcentajeAtraso"
          md="4"
          readonly
          prefix="%">
        </custom-text-field>
      </v-row>
      <v-toolbar
        flat>
        <v-toolbar-title>
          Partidas
        </v-toolbar-title>
      </v-toolbar>
      <v-row>
        <v-col
          cols="12">
          <listado-partidas
            :partidas="listadoDePartidas"
            :partidasImagenes="getPartidasImagenes"
            @reportarPartida="reportarPartida"
            @editarPartidaReportada="editarPartidaReportada"
            @removerPartidaReportada="removerPartidaReportada"
            ocultarRemover>
          </listado-partidas>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog
      v-if="estaPartida"
      v-model="mostrarReportarPartida"
      width="650"
      scrollable
      persistent>
      <v-card>
        <v-card-title>
          Reportar partida
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.reportarPartida.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <reportar-partida
            ref="reportarPartida"
            :partida="estaPartida"
            @guardar="guardarReportarPartida"
            @cerrar="cerrarReportarPartida">
          </reportar-partida>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.reportarPartida.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.reportarPartida.guardar()"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="estaPartida"
      v-model="mostrarEditarReportarPartida"
      width="650"
      scrollable
      persistent>
      <v-card>
        <v-card-title>
          Editar partida reportada
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.editarReportarPartida.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <editar-reportar-partida
            ref="editarReportarPartida"
            :partida="estaPartida"
            @guardar="guardarPartidaEditada"
            @cerrar="cerrarEditarReportarPartida">
          </editar-reportar-partida>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.editarReportarPartida.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.editarReportarPartida.guardar()"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixAvanceProgramado from '@/components/administracion/ejecucion/estimaciones/mixCalcularAvanceProgramado';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldOrange from '@/components/inputs/TextFieldOrange.vue';
import CustomTextFieldBlue from '@/components/inputs/TextFieldBlue.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import EditarReportarPartida from '../ReportarPartidaEditar.vue';
import ReportarPartida from '../ReportarPartida.vue';
import ListadoPartidas from '../ListadoPartidas.vue';
import mixReportesFisicos from '../mixReportesFisicos';
import {
  calcularAvancePonderado, limitarAvanceFisico, sumarAvancesPonderados,
} from '../avanceFisico';

export default {
  name: 'EditarReporteAvanceFisico',
  props: {
    contrato: {
      type: Object,
      required: true,
    },
    ultimoReporteFisico: {
      type: Object,
      required: true,
    },
  },
  components: {
    ListadoPartidas,
    ReportarPartida,
    EditarReportarPartida,
    CustomTextField,
    CustomTextFieldOrange,
    CustomTextFieldBlue,
    CustomDatePicker,
    CustomSelect,
    CustomTextArea,
    CustomButton,
  },
  mixins: [mixReportesFisicos, mixAvanceProgramado],
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      mostrarReportarPartida: false,
      mostrarEditarReportarPartida: false,
      estaPartida: null,
      imagenesPartdias: [],
      reporteFisico: {
        fecha: null, // ! String!,
        calidad: null, // ! Int!,
        comentarios: null, // ! String!,
        existeProblema: false, // Boolean,
        descripcionProblema: null, // String,
        avanceFisico: 0, // ! Float!,
        avanceProgramado: 0, // Float,
        avanceFinanciero: 0, // Float,
        partidas: [],
      },
      calidadTrabajos: [
        { id: 1, text: 'BUENA' },
        { id: 2, text: 'REGULAR' },
        { id: 3, text: 'MALA' },
      ],
    };
  },
  mounted() {
    const este = this;
    este.reporteFisico.fecha = este.ultimoReporteFisico?.fecha;
    este.reporteFisico.calidad = este.ultimoReporteFisico?.calidad;
    este.reporteFisico.comentarios = este.ultimoReporteFisico?.comentarios;
    este.reporteFisico.existeProblema = este.ultimoReporteFisico?.existeProblema;
    este.reporteFisico.descripcionProblema = este.ultimoReporteFisico?.descripcionProblema;
    este.reporteFisico.avanceFisico = este.ultimoReporteFisico?.avanceFisico;
    este.reporteFisico.avanceProgramado = este.ultimoReporteFisico?.avanceProgramado;
    este.fetchPartidas(este.ultimoReporteFisico?.partidas || []);
  },
  methods: {
    limparDescripcionProblema() {
      this.reporteFisico.descripcionProblema = null;
    },
    fetchPartidas(partidasReportadas) {
      this.reporteFisico.partidas = partidasReportadas
        .map((
          {
            id, idPartida, avanceFisico, ponderadoPartida, avancePonderado, comentario, imagenes,
          },
        ) => ({
          id,
          idPartida,
          avanceFisico,
          ponderadoPartida,
          avancePonderado,
          comentario,
          imagenes: imagenes || [],
          esNueva: false,
        }));
    },
    reportarPartida(partida) {
      this.estaPartida = partida;
      this.mostrarReportarPartida = true;
    },
    editarPartidaReportada(partida) {
      const partidaReportada = this.reporteFisico.partidas
        .find(({ idPartida }) => idPartida === partida.id);
      const nuevaPartida = {
        ...partida,
        reportado: partidaReportada,
      };
      this.estaPartida = nuevaPartida;
      this.mostrarEditarReportarPartida = true;
    },
    guardarReportarPartida(partida) {
      const { partidas } = this.reporteFisico;
      console.error('partida', partida);
      partidas.push({
        ...partida,
        esNueva: true,
      });
      this.mostrarReportarPartida = false;
      this.estaPartida = null;
    },
    guardarPartidaEditada(partida) {
      const { partidas } = this.reporteFisico;
      const index = partidas.findIndex(({ idPartida }) => idPartida === partida.idPartida);
      const partidaOld = partidas[index];
      partidas.splice(index, 1, {
        ...partida,
        id: partidaOld.id,
        esNueva: false,
      });
      this.mostrarEditarReportarPartida = false;
      this.estaPartida = null;
    },
    removerPartidaReportada(partida) {
      const { id } = partida;
      const index = this.reporteFisico.partidas
        .findIndex(({ idPartida }) => idPartida === id);

      this.reporteFisico.partidas.splice(index, 1);
    },
    cerrarReportarPartida() {
      this.mostrarReportarPartida = false;
      this.estaPartida = null;
    },
    cerrarEditarReportarPartida() {
      this.mostrarEditarReportarPartida = false;
      this.estaPartida = null;
    },
    limpiarFormulario() {
      this.reporteFisicofecha = new Date().toISOString().substr(0, 10);
      this.reporteFisico.calidad = null;
      this.reporteFisico.comentarios = null;
      this.reporteFisico.existeProblema = false;
      this.reporteFisico.descripcionProblema = null;
      this.reporteFisico.partidas = [];
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    getPartidasImagenes() {
      const { partidas } = this.reporteFisico;
      const imagenesPartidas = partidas
        .slice()
        .map(({ idPartida, imagenes }) => ({
          idPartida,
          imagenes,
        }));
      return imagenesPartidas;
    },
    importeContratoCostoDirecto() {
      if (!this.contrato) return 0;
      const { importe: importeModificado } = this.contrato.modificado;
      if (this.contrato.esObraFinanciada) {
        return (this.contrato.importeCostoDirecto + importeModificado);
      }
      return (this.contrato.importe + importeModificado);
    },
    importeDelContrato() {
      if (!this.contrato) return 0;
      const { importe: importeModificado } = this.contrato.modificado;
      if (this.contrato.esObraFinanciada) {
        return (this.contrato.importeTotal + importeModificado);
      }
      return (this.contrato.importe + importeModificado);
    },
    listadoDePartidas() {
      const partidasReportadas = this.reporteFisico.partidas.map(({ idPartida }) => idPartida);
      return this.mixGetCatalogoConceptosPartidas
        .map((partida) => ({
          ...partida,
          fueReportada: partidasReportadas.includes(partida.id),
        }))
        .map((partida) => {
          const partidaReportada = this.reporteFisico.partidas
            .find(({ idPartida }) => idPartida === partida.id);

          const avanceFisico = partidaReportada
            ? partidaReportada.avanceFisico : partida.avanceFisico;
          const ponderadoPartida = partidaReportada
            ? partidaReportada.ponderadoPartida : partida.ponderadoPartida;
          return {
            ...partida,
            avanceFisico: limitarAvanceFisico(avanceFisico),
            ponderadoPartida,
            avancePonderado: calcularAvancePonderado(ponderadoPartida, avanceFisico),
          };
        });
    },
    getSumarAvancePoderado() {
      if (this.reporteFisico.partidas.length <= 0) {
        return limitarAvanceFisico(this.ultimoReporteFisico?.avanceFisico || 0);
      }
      return sumarAvancesPonderados(this.listadoDePartidas);
    },
    porcentajeAtraso() {
      if (this.reporteFisico.avanceProgramado <= 0 || this.getSumarAvancePoderado <= 0) return 0;
      return this.$numberRoundDigits(
        (this.reporteFisico.avanceProgramado - this.getSumarAvancePoderado),
        2,
      );
    },
    tituloPorcentajeAtraso() {
      if (this.porcentajeAtraso > 0) return 'Atraso';
      return 'A tiempo';
    },
  },
  watch: {
    'reporteFisico.fecha': {
      handler(fecha) {
        if (fecha === this.ultimoReporteFisico.fecha) {
          this.reporteFisico.avanceProgramado = this.ultimoReporteFisico.avanceProgramado;
        } else {
          const { porcentaje } = this.mixCalcularPrograma(fecha);
          this.reporteFisico.avanceProgramado = porcentaje || 0;
        }
      },
    },
    'reporteFisico.partidas': {
      handler() {
        this.reporteFisico.avanceFisico = this.getSumarAvancePoderado;
      },
    },
    ultimoReporteFisico: {
      handler(reporte) {
        this.reporteFisico.fecha = reporte.fecha;
        this.reporteFisico.calidad = reporte.calidad;
        this.reporteFisico.comentarios = reporte.comentarios;
        this.reporteFisico.existeProblema = reporte.existeProblema;
        this.reporteFisico.descripcionProblema = reporte.descripcionProblema;
        this.reporteFisico.avanceFisico = reporte.avanceFisico;
        this.fetchPartidas(reporte.partidas || []);
      },
    },
    formularioValido: {
      handler(formularioValido) {
        this.$emit('formularioValido', formularioValido);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
